module.exports = __webpack_public_path__ + "static/media/fr_CO2.a4712283.svg";